import { render, staticRenderFns } from "./RePasswordForm.vue?vue&type=template&id=7e987cfe&scoped=true&"
import script from "./RePasswordForm.vue?vue&type=script&lang=ts&"
export * from "./RePasswordForm.vue?vue&type=script&lang=ts&"
import style0 from "./RePasswordForm.vue?vue&type=style&index=0&id=7e987cfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e987cfe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e987cfe')) {
      api.createRecord('7e987cfe', component.options)
    } else {
      api.reload('7e987cfe', component.options)
    }
    module.hot.accept("./RePasswordForm.vue?vue&type=template&id=7e987cfe&scoped=true&", function () {
      api.rerender('7e987cfe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/components/RePasswordForm.vue"
export default component.exports